
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-spectrogram';
      import { GGWave } from '@folkjs/labs/ggwave';

      const wave = new GGWave();
      const spectrogram = document.getElementById('spectrogram');
      const messageToSend = document.getElementById('messageToSend');
      const receivedMessages = document.getElementById('receivedMessages');
      const sendButton = document.getElementById('sendButton');
      const modeToggle = document.getElementById('modeToggle');
      const listenButton = document.getElementById('listenButton');

      let isUltrasonic = false;

      // Set up audio visualization
      wave.setVisualizer((node, context) => {
        if (node) {
          spectrogram.connect(node, context);
          spectrogram.start();
        } else {
          spectrogram.stop();
        }
      });

      // Toggle between audible and ultrasonic modes
      modeToggle.addEventListener('click', () => {
        isUltrasonic = !isUltrasonic;
        modeToggle.textContent = `Ultrasonic: ${isUltrasonic ? 'On' : 'Off'}`;
        modeToggle.classList.toggle('active', isUltrasonic);
        wave.setProtocol(
          isUltrasonic
            ? FolkAudioWave.GGWAVE_PROTOCOL_ULTRASOUND_FASTEST
            : FolkAudioWave.GGWAVE_PROTOCOL_AUDIBLE_FASTEST,
        );
      });

      // Send message
      sendButton.addEventListener('click', async () => {
        if (!messageToSend.value.trim()) return;

        // Disable button while sending
        sendButton.disabled = true;
        try {
          await wave.send(messageToSend.value, 10);
        } catch (error) {
          console.error('Failed to send message:', error);
        }
        sendButton.disabled = false;
      });

      // Listen for messages
      listenButton.addEventListener('click', async () => {
        const isListening = listenButton.textContent === 'Stop Listening';

        if (isListening) {
          wave.stopListening();
          listenButton.textContent = 'Start Listening';
          listenButton.classList.remove('active');
          receivedMessages.value = '';
        } else {
          listenButton.textContent = 'Stop Listening';
          listenButton.classList.add('active');
          await wave.startListening((text) => {
            const timestamp = new Date().toLocaleTimeString();
            receivedMessages.value = `[${timestamp}] ${text}\n${receivedMessages.value}`;
          });
        }
      });

      // Stop listening by default
      wave.stopListening();
    